<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <v-alert text color="grey darken-1" class="p-4 rounded-lg " elevation="0">
                    <v-row style="line-height: 2rem;padding-left:20px;color: #000;">
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>Nama</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user.name }}</td>
                            </tr>
                            <tr>
                                <td><strong>NIM</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user.no_induk }}</td>
                            </tr>
                            <tr>
                                <td><strong>Email</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user.email }}</td>
                            </tr>
                        </v-col>
                        <v-col cols="12" md="6" sm="6" v-if="$isFTI">
                            <tr>
                                <td><strong>No. Hp</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user.no_hp }}</td>
                            </tr>
                            <tr>
                                <td><strong>IPK</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user.ipk }}</td>
                            </tr>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-stepper v-model="step" vertical elevation="0">
                    <v-stepper-step complete step="1" @click="step = 1" style="cursor: pointer;">
                        Pendaftaran
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-alert v-if="kp !== null && kp.level_aproval_sekarang == 3" border="left" color="red lighten-2"
                            dark>
                            <div>
                                <h6 class="text-body-1"><strong>Perlu perbaikan</strong></h6>
                                <p class="text-caption mb-1">Catatan: {{ kp.catatan }}</p>
                            </div>
                        </v-alert>
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Isian<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                <v-row>
                                    <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Tanggal daftar di sistem</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.created_at }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Rencana mulai kp</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.tanggal_rencana_mulai_kp }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Rencana selesai kp</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.tanggal_rencana_selesai_kp }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Kuliah prasyarat</label>
                                        <v-alert dense class="rounded-lg" elevation="1"
                                            v-if="kp.matakuliah_prasyarat.length > 0">
                                            <div class="d-flex">
                                                <div class="text-body-2 mr-1"
                                                    v-for="(vals, indexItem) in kp.matakuliah_prasyarat">
                                                    <v-chip>{{ (indexItem + 1) + '. ' + vals.matakuliah
                                                    }}</v-chip>
                                                </div>
                                            </div>
                                        </v-alert>
                                        <v-alert dense class="rounded-lg" elevation="1" v-else>
                                            -
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0" v-if="$isFTI">
                                        <label class="mb-2 font-weight-bold">IPK</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.ipk }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0" v-if="$isFTI">
                                        <label class="mb-2 font-weight-bold">SKS</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.sks }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col>
                                        <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                            <label class="mb-2 font-weight-bold">Kategori perusahaan</label>
                                            <v-alert dense class="rounded-lg" elevation="1">
                                                <div class="d-flex justify-space-between">
                                                    <div class="text-body-2">
                                                        {{ kp.kategori_perusahaan.name }}
                                                    </div>
                                                </div>
                                            </v-alert>
                                        </v-col>
                                        <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                            <label class="mb-2 font-weight-bold">Bidang topik</label>
                                            <v-alert dense class="rounded-lg" elevation="1">
                                                <div class="d-flex justify-space-between">
                                                    <div class="text-body-2">
                                                        {{ kp.bidang_topik.name }}
                                                    </div>
                                                </div>
                                            </v-alert>
                                        </v-col>
                                        <v-col cols="12" sm="12" class="p-0">
                                            <label class="mb-2 font-weight-bold">Nama perusahaan tujuan</label>
                                            <v-alert dense class="rounded-lg" elevation="1">
                                                <div class="d-flex justify-space-between">
                                                    <div class="text-body-2">
                                                        {{ kp.perusahaan_tujuan }}
                                                    </div>
                                                </div>
                                            </v-alert>
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0 mt-2">
                                        <label class="mb-2 font-weight-bold">Alamat perusahaan</label>
                                        <v-alert dense class="rounded-lg" elevation="1" min-height="120px">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.alamat_perusahaan }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                                <v-divider class="indigo--text mb-0"></v-divider>
                                <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                <v-row>
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0" v-for="( doc, index ) in kp.dokumen"
                                        v-bind:key="doc.id">
                                        <label class="mb-2 font-weight-bold">{{ (index + 1) +
                                            '. ' + doc.nama_jenis_dokumen }}</label>
                                        <div v-if="doc.dokumen.length > 0">
                                            <v-alert dense class="rounded-lg" elevation="1"
                                                v-for="( file, fileIndex ) in doc.dokumen" v-bind:key="file.id">
                                                <div class="d-flex justify-space-between">
                                                    <h6 class="text-body-2 mb-0">
                                                        {{ file.nama_dokumen }}
                                                        <p class="text-caption text-muted mb-0"> {{
                                                            $dates.dateNoDayWithTime(file.created_at) }}</p>
                                                    </h6>
                                                    <a style="text-decoration:none;" :href="file.url" target="_blank">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </a>
                                                </div>
                                            </v-alert>
                                        </div>
                                        <div v-else>
                                            <v-alert dense class="rounded-lg" elevation="1">
                                                <div class="d-flex justify-space-between">
                                                    <div class="text-body-2 text-muted font-italic">
                                                        Tidak memiliki dokumen
                                                    </div>
                                                </div>
                                            </v-alert>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-btn v-if="kp !== null && kp.level_aproval_sekarang >= 4" color="primary" @click="step = 2">
                            Selanjutnya
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="2" :complete="kp.level_aproval_sekarang > 4"
                        @click="kp.level_aproval_sekarang >= 4 ? step = 2 : null" style="cursor:pointer;">
                        Unggah Surat Balasan
                        <small>Realisasi mulai KP, Surat balasan</small>
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <v-card class="p-3 mb-3 indigo lighten-5" v-if="kp.level_aproval_sekarang >= 1">
                                    Surat pengantar ke perusahaan sudah tersedia.
                                    <p class="text-caption">Unduh <strong>Surat pengantar</strong> ke perusahaan, dan
                                        tunggu surat balasan. <strong>Surat balasan diterima</strong>
                                        perusahaan diperlukan untuk melanjutkan kp.</p>
                                    <v-row>
                                        <a :href="urlCetakSuratPengantar()">
                                            <v-col cols="12" md="6" sm="12" class="pb-0">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">pengantar_perusahaan.pdf</p>
                                                </v-alert>
                                            </v-col>
                                        </a>
                                    </v-row>
                                </v-card>
                                <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Mulai KP<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                <v-row class="pt-2">
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Tanggal realisasi mulai KP</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.tanggal_realisasi_mulai_kp || '-' }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">{{ kp.surat_balasan.jenis_surat.jenis_surat ||
                                            '-' }}</label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2">
                                                    {{ kp.surat_balasan.nama || '-' }}
                                                </div>
                                                <a style="text-decoration:none;" :href="kp.surat_balasan.url || '#'"
                                                    target="_blank">
                                                    <v-icon>mdi-eye</v-icon>
                                                </a>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-btn text color="indigo" outlined @click="step = 1">
                            Sebelumnya
                        </v-btn>
                        <v-btn color="primary" v-if="kp !== null && kp.level_aproval_sekarang >= 7" @click="step = 3">
                            Selanjutnya
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="3" :complete="kp.level_aproval_sekarang > 7"
                        @click="kp.level_aproval_sekarang >= 7 ? step = 3 : null" style="cursor:pointer;">
                        Unggah Laporan KP
                        <small>Laporan KP, Logbook Kegiatan, Lembar penilaian</small>
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <v-card text class="p-3 mb-5 rounded-lg indigo lighten-5">
                                    Unduh dokumen
                                    <p class="text-caption">Dokumen tersebut akan digunakan untuk syarat selesai KP pada
                                        tahap selanjutnya</p>
                                    <v-row>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="urlCetakSuratKonfirmasi()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">konfirmasi_penerimaan.pdf</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarPenilaianPembimbing()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">penilaian_pembimbing.docx</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarKonsultasi()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">lembar_konsultasi.docx</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarKegiatan()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">lembar_kegiatan.docx</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Dosen pembimbing<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                <v-row class="pt-2">
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                        <label class="mb-2 font-weight-bold">Dosen pembimbing </label>
                                        <v-alert dense class="rounded-lg" elevation="1">
                                            <div class="d-flex justify-space-between">
                                                <div class="text-body-2" v-if="kp !== null">
                                                    {{ kp.dosen_pembimbing.length > 0 ? kp.dosen_pembimbing[0].name : '-' }}
                                                </div>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                                <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                </h6>
                                <v-row v-if="kp.laporan">
                                    <v-col cols="12" sm="12" md="6" class="pb-0 pt-0"
                                        v-for="(doc, index) in $dokumen.laporan(kp.laporan)" v-bind:key="doc.id">
                                        <label class="mb-2 font-weight-bold">
                                            {{ (index + 1) + '. ' + doc.nama_jenis_dokumen }}</label>
                                        <div v-if="doc.dokumen.length > 0">
                                            <v-alert dense class="rounded-lg" elevation="1"
                                                v-for="(file, indexFile) in doc.dokumen" v-bind:key="file.id">
                                                <div class="d-flex justify-space-between">
                                                    <h6 class="text-body-2 mb-0">
                                                        {{ file.nama_dokumen }}
                                                        <p class="text-caption text-muted mb-0"> {{
                                                            $dates.dateNoDayWithTime(file.created_at) }}</p>
                                                    </h6>
                                                    <a style="text-decoration:none;" :href="file.url" target="_blank">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </a>
                                                </div>
                                            </v-alert>
                                        </div>
                                        <div v-else>
                                            <v-alert dense class="rounded-lg" elevation="1">
                                                <div class="d-flex justify-space-between">
                                                    <div class="text-body-2 text-muted font-italic">
                                                        Belum mengunggah dokumen
                                                    </div>
                                                </div>
                                            </v-alert>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-btn text color="indigo" outlined @click="step = 2">
                            Sebelumnya
                        </v-btn>
                        <v-btn color="primary" v-if="kp.level_aproval_sekarang > 10" @click="step = 4">
                            Selanjutnya
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="4" :complete="kp.level_aproval_sekarang > 10"
                        @click="kp.level_aproval_sekarang > 10 ? step = 4 : null">
                        Selesai
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-card class="mb-12 indigo lighten-5" elevation="0">
                            <v-container class="p-4">
                                <v-alert type="success" text dense> <strong> Kerja Praktik telah selesai.</strong><br>
                                    Terimakasih telah menjalankan Kerja praktik sebaik-baiknya.
                                    <h4>Nilai anda: <span class="font-weight-bold indigo--text text--darken-4 text-h4">{{
                                        $nilai.tampil(kp.nilai_angka, kp.nilai_huruf) }}</span></h4>
                                </v-alert>
                            </v-container>
                        </v-card>
                        <v-btn text color="indigo" outlined @click="step = 3">
                            Sebelumnya
                        </v-btn>
                    </v-stepper-content>
                </v-stepper>
                <div class="d-flex justify-content-center">
                    <v-btn outlined color="primary" @click="buttonBackClick()">
                        Kembali
                    </v-btn>
                </div>
            </template>
        </v-container>
    </v-row>
</template>
<script>
export default {
    data: () => ({
        step: 1,
        tabs: null,
        kpid: undefined,
        user: undefined,
        kp: undefined
    }),
    created() {
        this.kpid = this.$route.query.uuid.split('$')[0];
        this.getData();
    },
    methods: {
        urlCetakSuratKonfirmasi() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-konfirmasi';
        },
        getData() {
            this.axios.get("/api/mahasiswa/kp/" + this.kpid).then((res) => {
                this.user = res.data.data;
                this.kp = this.user.kp;
                this.kp.created_at = this.$dates.dateNoDayNoTime(this.kp.created_at);
                this.kp.tanggal_realisasi_mulai_kp !== null ? this.kp.tanggal_realisasi_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_mulai_kp) : '-';
                this.kp.tanggal_realisasi_selesai_kp !== null ? this.kp.tanggal_realisasi_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_selesai_kp) : '-';
                this.kp.tanggal_rencana_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_mulai_kp);
                this.kp.tanggal_rencana_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_selesai_kp);
                this.getStep(this.kp.level_aproval_sekarang);
            })
                .catch((err) => console.log(this.kp = null))
                .finally(() => console.log(this.kp, 'KPs'));
        },
        getStep(level) {
            switch (level) {
                case '1':
                    this.step = 1;
                    break;
                case '4':
                    this.step = 2;
                    break;
                case '7':
                    this.step = 3;
                    break;
                case '10':
                    this.step = 3;
                    break;
                case '11':
                    this.step = 4;
                    break;

                default:
                    break;
            }
        },
        urlCetakSuratPengantar() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-pengantar';
        },
        buttonBackClick() {
            this.$router.push({ name: "home" });
        },
    }
}
</script>
<style>
.card-file-download {
    font-size: calc(0.5em + 1vmin);
    cursor: pointer;

}

.card-file-download:hover {
    transform: scale(1.02);
    opacity: 0.5;
}

@media only screen and (max-width: 600px) {
    .card-file-download {
        font-size: calc(0.3em + 1vmin);
    }
}
</style>